import { PostBaseBusinessToForecastForReceiptRequest } from '@/coreInfrastructureModule/axios/generated/forecastForReceiptManage/api';

/**
 * 関連取引を受領用内示に追加するアダプタ
 */
export class PostBaseBusinessForecastForReceiptAdapter {
  /**
   * リクエストをAPI用に変換する
   * @param baseBusinessIds - 集計ID
   * @param forecastForReceiptId - グループID
   */
  public static adaptForRequest(baseBusinessIds: string[], forecastForReceiptId: string): PostBaseBusinessToForecastForReceiptRequest {
    return {
      postBaseBusinessToForecastForReceiptInfo: {
        baseBusinessIds: baseBusinessIds,
        forecastForReceiptId: forecastForReceiptId,
      },
    };
  }
}
